module.exports = __webpack_public_path__ + "img/Maattekening dubbelwerkende cilinder met Standaard bevestiging.e520c78f.jpg";